// Entry point for the build script in your package.json
import React from "react";
import { createRoot } from "react-dom/client";
import components from "./components";
import { setupDropdowns, setupConfirmations } from "./lib/ui";
import { setupTextSize } from "./lib/text_size";

function mountReactComponents() {
	document.querySelectorAll("[data-react-component]").forEach((el) => {
		const name = el.dataset.reactComponent;
		const Component = components[name];

		if (!Component) {
			console.error(`React component "${name}" not found in registry.`);
			return;
		}

		let props = {};
		if (el.dataset.reactProps) {
			try {
				props = JSON.parse(el.dataset.reactProps);
			} catch (e) {
				console.error(`Invalid JSON in data-react-props for "${name}":`, e);
				return;
			}
		}

		const root = createRoot(el);
		root.render(React.createElement(Component, props));
	});
}

document.addEventListener("DOMContentLoaded", mountReactComponents);
setupDropdowns();
setupConfirmations();
setupTextSize();
